import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
  widgetAlert: {
    padding: theme.spacing(1),
    width: '100%',
  },
}));

const WidgetAlert = (props) => {
  const { alertMassage } = props;
  const classes = useStyles();
  return (
    <Box className={classes.widgetAlert}>
      <Alert severity="error">{alertMassage}</Alert>
    </Box>
  );
};
export default WidgetAlert;
